export default {
    getRequestError(state){
      return state.request_error;
    },
    getProducts(state) {
      return state.products_of_search;
    },
    getProduct(state) {
      return state.product;
    },
  };